import { render } from "./Intro.vue?vue&type=template&id=d9031d04&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=d9031d04&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9031d04"]])

export default __exports__